export const colors =  [
    "#d76735",
    "#9bcaf5",
    "#f4d066",
    "#f9786e",
    "#a13dff",
    "#f2d8b3",
    "#90b1aa",
    "#8fce00",
    "#352753",
    "#fdf498",
    "#0392cf",
    "#bcbad7",
    "#b5f4ed",
    "#b5f4c8"
]